<header color="primary" >
    <button class="fa fa-chevron-circle-left bg-primary" type="button" (click)="back()"></button>
  <h6> Pay with available balance</h6>
</header>
  <div class="container ">
    <div>
      <h6 >Available Balance :</h6>
      <h4>{{availableBalance}} EGP</h4>
    </div>
    <div>
      <h6>Bill Amount :</h6>
      <h4>{{billAmount}} EGP</h4>
    </div>
    <div class="d-flex justify-content-center align-items-center">
      <button *ngIf="!success" type="button" class="btn btn-success" (click)="pay()">Pay with balance</button>
    </div>
    <div *ngIf="status==='SUCCESS'" class="mt-2 alert alert-success" role="alert">
      payment submitted successfully
      <button class="fa fa-chevron-circle-left" type="button" (click)="back()"></button>
    </div>
    <!-- <div *ngIf="status==='FAILED'" class="mt-2 alert alert-danger" role="alert">
      {{errorMsg}}
      <button class="fa fa-chevron-circle-left" type="button" (click)="back()"></button>
    </div> -->

</div>
